module.exports = "img/flags/MM.37c1518.png";